const passengerSchema = {
  name: '',
  surnames: '',
  passport: '',
  birthdate: null,
  issueDate: null,
  expirationDate: null,
  type: '',
  gender: '',
  documentType: '',
  countryOfResidence: '',
}

const passengerTypes = [
  {
    value: 'Adult',
    label: 'Adulto',
  },
  {
    value: 'Children',
    label: 'Niño',
  },
  {
    value: 'Infant',
    label: 'Bebé',
  },
]

const passengerGenders = [
  {
    value: 'Male',
    label: 'Hombre',
  },
  {
    value: 'Female',
    label: 'Mujer',
  },
]

const passengerDocumentTypes = [
  {
    value: 'DNI_NIF',
    label: 'DNI/NIF',
  },
  {
    value: 'NIE',
    label: 'NIE',
  },
  {
    value: 'PASSPORT',
    label: 'passenger.passport',
  },
  {
    value: 'DNI_EXTRANJERO',
    label: 'passenger.dni_extranjero',
  },
]

export default {
  passengerSchema,
  passengerTypes,
  passengerGenders,
  passengerDocumentTypes,
}
